import { trigger, transition, group, query, animateChild, state, style, animate } from '@angular/animations';
import { appConfig } from 'src/config';

const _slideTime = appConfig.centralPage_pageSlide_time;
const _enterTime = appConfig.show_enter_time;
const _leaveTime = appConfig.show_leave_time;

export const centralPageAnimation = [
    trigger('slideTabsBox', [
        transition('visible <=> hidden', [
            group([
                query('@showHide', animateChild(), { optional: true }),
            ])
        ])
    ]),
    // slideTabButtons verwijderd: de vlottende tab-knoppen volgden hardgecodeerde per-stand
    // bottom-offsets (2.5em/2.68em/5.18em) gekalibreerd op de ingeklapte filterbalk. Nu volgen ze
    // de werkelijke hoogte van .pager-container via een ResizeObserver in tablist-footer
    // ([style.bottom.px]), zodat ze ook meeschuiven als het filterpaneel/chips de balk hoger maken.
    // slideDetailsSection verwijderd: de hoogte van .details-section wordt nu signal-gedreven
    // ([style.height] + CSS-transition in tab-page), niet meer via een animatie-state.
    // trigger('slideDetailsWidth', [
    //     state('edit-page, create-page, details-page', style({ width: _detailsWidth })),
    //     state('tab-page', style({ width: '90%' })),
    //     transition('* <=> tab-page', [
    //         group([
    //             animate(`${_slideTime} ease-in-out`),
    //             query('@slidePageSheetWidth', animateChild(), { optional: true }),
    //         ]),
    //     ]),
    // ]),
    trigger('slidePageSheetWidth', [
        // state('small', style({ marginLeft: '10%', marginRight: '10%' })),
        // state('wide', style({ marginLeft: '0', marginRight: '0' })),
        transition('small <=> wide', [
            group([
                animate(`${_slideTime} ease-in-out`),
                query('@resizeImageBox', animateChild(), { optional: true }),
                query('@slideControlsBox', animateChild(), { optional: true }),
                query('@showHide', animateChild(), { optional: true }),
            ]),
        ]),
    ]),
    trigger('resizeImageBox', [
        state('large', style({ width: '11.1em' })),
        state('small', style({ width: '7em' })),
        transition('* <=> large', [animate(`${_slideTime} ease-in-out`)]),
    ]),
    // Reveal = hoogte + opacity. De breedte zit bewust NIET meer in de animatie: die wordt
    // volledig door CSS bepaald (responsieve veld-inzet links, rechterrand vast op de inset),
    // zodat de open-/dichtbeweging resolutie-onafhankelijk is en de rechterkant niet verspringt.
    trigger('slideControlsBox', [
        transition(':enter', [
            style({ height: '0', opacity: '0' }),
            group([
                animate('{{enterTime}} ease-in-out', style({ height: '*', opacity: '1' })),
                query('@showHide', animateChild({params: {enterTime: _enterTime}}), { optional: true }),
            ]),
        ],
        { params: {enterTime: _enterTime} }),
        transition(':leave', [
            style({ height: '*', opacity: '1' }),
            group([
                animate('{{leaveTime}} ease-in-out', style({ height: '0', opacity: '0' })),
                query('@showHide', animateChild({params: {_leaveTime: _leaveTime}}), { optional: true }),
            ]),
        ],
        { params: {leaveTime: _leaveTime} }),
    ]),
];
